import { render } from "./FreeBenefits.vue?vue&type=template&id=3d0d2f39&scoped=true"
import script from "./FreeBenefits.vue?vue&type=script&lang=js"
export * from "./FreeBenefits.vue?vue&type=script&lang=js"

import "./FreeBenefits.vue?vue&type=style&index=0&id=3d0d2f39&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0d2f39"]])

export default __exports__